// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserInitiatePasswordResetInitiatePasswordResetResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserInitiatePasswordResetInitiatePasswordResetResponse.attributeTypeMap;
    }
}
AuthenticationV2UserInitiatePasswordResetInitiatePasswordResetResponse.discriminator = undefined;
AuthenticationV2UserInitiatePasswordResetInitiatePasswordResetResponse.additionalProperties = false;
AuthenticationV2UserInitiatePasswordResetInitiatePasswordResetResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=authenticationV2UserInitiatePasswordResetInitiatePasswordResetResponse.js.map